import React, { useEffect, useState } from 'react';
import { Checkbox } from '@components';
import { useSelector } from 'react-redux';
import { PLANO_TAESA } from '../../../../common/utils/plans';

export const Beneficiario = ({
  values,
  checkedArray,
  onCheck,
  onUnchecked,
  disabledCheckbox,
}) => {
  const [isChecked, setIsChecked] = useState(false);
  const checked = checkedArray.find((x) => values.id === x.id);
  const user = useSelector((state) => state.user);

  const handleCheck = (e) => {
    if (e.target.checked) {
      setIsChecked(true);
      onCheck(values);
    } else {
      setIsChecked(false);
      onUnchecked(values);
    }
  };

  useEffect(() => {
    setIsChecked(!!checked);
  }, []);

  return (
    <div className={`checkbox_card ${isChecked ? 'checked' : ''}`}>
      {!disabledCheckbox && (
        <Checkbox
          className="beneficiario_checkbox"
          defaultChecked={!!checked}
          onChange={handleCheck}
          disabledCheckbox={disabledCheckbox}
        />
      )}
      <div className="w-100">
        <p className="ts-18 fw-bold mb-3 text-truncate">{values.nome}</p>
        <div className="d-flex justify-content-between">
          {user.plano !== PLANO_TAESA && <p className="ts-14">Parentesco</p>}
          {user.plano !== PLANO_TAESA && (
            <p className="ts-14">{values.parentesco}</p>
          )}
        </div>
        <div className="d-flex justify-content-between">
          <p className="my-3 ts-14">Nascimento</p>
          <p className="my-3 ts-14">{values.nascimento}</p>
        </div>
      </div>
    </div>
  );
};
